export default [
  {
    path: "/investigationTypeConfig",
    component: () =>
      import(
        /* webpackChunkName: "config" */ "@/views/config/investigationTypeConfig/index"
      ),
    name: "investigationTypeConfig",
    meta: {
      isTab: true,
      keepAlive: false,
      links: ["调查项目配置"],
      permissionsPath: "/investigationTypeConfig"
    }
  },
  {
    path: "/investigationTypeConfigDetail",
    component: () =>
      import(
        /* webpackChunkName: "config" */ "@/views/config/investigationTypeConfig/detail"
      ),
    name: "investigationTypeConfigDetail",
    meta: {
      isTab: true,
      keepAlive: false,
      links: ["调查项目详情"],
      permissionsPath: "/investigationTypeConfig"
    }
  },
  {
    path: "/investigationTypeRelation",
    component: () =>
      import(
        /* webpackChunkName: "config" */ "@/views/config/investigationTypeRelation/index"
      ),
    name: "investigationTypeRelation",
    meta: {
      isTab: true,
      keepAlive: false,
      links: ["调查项目映射"],
      permissionsPath: "/investigationTypeRelation"
    }
  }
];
